import { passMessages } from "./passes";
import { eventMessages } from "./events";
import type { PortalLocale } from "../lib/portalPreferences";
import { directoryMessages } from "./directory";
import { portalMessages } from "./portal";
import { profileMessages } from "./profile";
import { postMessages } from "./posts";
import { communityMessages } from "./community";
import { reservationMessages } from "./reservation";

const czechMessages = {
  "common.description": "Váš klientský prostor pro služby, rezervace a spolupráci.",
  ...directoryMessages.cs,
  ...eventMessages.cs,
  ...passMessages.cs,
  ...portalMessages.cs,
  ...profileMessages.cs,
  ...postMessages.cs,
  ...communityMessages.cs,
  ...reservationMessages.cs,
} as const;

export type PortalTranslationKey = keyof typeof czechMessages;
export type PortalTranslationValues = Record<string, string | number>;
export type PortalTranslator = (key: PortalTranslationKey, values?: PortalTranslationValues) => string;

export const portalMessagesByLocale: Record<PortalLocale, Record<PortalTranslationKey, string>> = {
  cs: czechMessages,
  en: {
    "common.description": "Your client space for services, bookings and collaboration.",
    ...directoryMessages.en,
    ...eventMessages.en,
    ...passMessages.en,
    ...portalMessages.en,
    ...profileMessages.en,
    ...postMessages.en,
    ...communityMessages.en,
    ...reservationMessages.en,
  },
};

export function createPortalTranslator(locale: PortalLocale): PortalTranslator {
  const plurals = new Intl.PluralRules(locale);
  const messages = portalMessagesByLocale[locale];
  return (key, values) => {
    const pluralKey = typeof values?.count === "number" ? `${key}.${plurals.select(values.count)}` as PortalTranslationKey : key;
    return (messages[pluralKey] ?? messages[key]).replace(/\{(\w+)\}/g, (placeholder, name: string) => (
      values && Object.hasOwn(values, name) ? String(values[name]) : placeholder
    ));
  };
}
